/**
 * Les mots d'une invitation au compte qui doivent sauter aux yeux, pour `<Trans>` :
 * `<b>` = le verbe d'action en gras, `<pts>` = les points en pastille couleur
 * d'accent. Le texte de la pastille suit `--on-accent`, dérivé du thème : il reste
 * lisible quelle que soit la couleur d'accent du restaurant.
 */
export const NUDGE_EMPHASIS = {
  b: <strong className="font-bold text-ink" />,
  pts: (
    <strong className="whitespace-nowrap rounded-btn-sm bg-hot-pink px-1.5 font-bold text-[var(--on-accent)]" />
  ),
};
